var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-terminal-setup"
  }, [_c('div', {
    staticClass: "setup-card"
  }, [_vm._m(0), _vm.passo === 1 ? _c('div', {
    staticClass: "setup-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "uuid_terminal"
    }
  }, [_vm._v("Identificador do Terminal *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.uuid_terminal,
      expression: "form.uuid_terminal"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.erros.uuid_terminal
    },
    attrs: {
      "id": "uuid_terminal",
      "type": "text",
      "placeholder": "Ex.: caixa-01"
    },
    domProps: {
      "value": _vm.form.uuid_terminal
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "uuid_terminal", $event.target.value);
      }
    }
  }), _vm.erros.uuid_terminal ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" " + _vm._s(_vm.erros.uuid_terminal) + " ")]) : _vm._e(), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" Deve estar cadastrado na sua conta. ")])]), _vm.erroGeral ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.erroGeral))]) : _vm._e(), _c('div', {
    staticClass: "setup-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.validando
    },
    on: {
      "click": _vm.validarTerminal
    }
  }, [_vm.validando ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v(" Validando... ")]) : _c('span', [_vm._v("Validar Terminal")])])])]) : _vm._e(), _vm.passo === 2 ? _c('div', {
    staticClass: "setup-form"
  }, [_c('div', {
    staticClass: "terminal-info-box"
  }, [_c('div', {
    staticClass: "terminal-info-box__row"
  }, [_c('span', {
    staticClass: "terminal-info-box__label"
  }, [_vm._v("Terminal")]), _c('span', {
    staticClass: "terminal-info-box__value"
  }, [_vm._v(_vm._s(_vm.terminalDados.nome || _vm.form.uuid_terminal))])]), _c('div', {
    staticClass: "terminal-info-box__row"
  }, [_c('span', {
    staticClass: "terminal-info-box__label"
  }, [_vm._v("Série NF-e")]), _c('span', {
    staticClass: "terminal-info-box__value"
  }, [_vm._v(_vm._s(_vm.terminalDados.serie || '—'))])]), _c('div', {
    staticClass: "terminal-info-box__row"
  }, [_c('span', {
    staticClass: "terminal-info-box__label"
  }, [_vm._v("Próxima venda")]), _c('span', {
    staticClass: "terminal-info-box__value"
  }, [_vm._v("#" + _vm._s(_vm.terminalDados.proxima_venda || 1))])])]), _vm.erroGeral ? _c('div', {
    staticClass: "alert alert-danger mt-3"
  }, [_vm._v(_vm._s(_vm.erroGeral))]) : _vm._e(), _vm.sincronizando ? _c('div', {
    staticClass: "sync-progress mt-3"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped progress-bar-animated bg-primary",
    style: {
      width: _vm.progresso + '%'
    }
  })]), _c('p', {
    staticClass: "sync-status mt-1"
  }, [_vm._v(_vm._s(_vm.statusSync))])]) : _vm._e(), _vm.sucesso ? _c('div', {
    staticClass: "alert alert-success mt-3"
  }, [_vm._v(" ✓ Terminal configurado! Abrindo o painel... ")]) : _vm._e(), _c('div', {
    staticClass: "setup-actions mt-3"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando
    },
    on: {
      "click": function click($event) {
        _vm.passo = 1;
      }
    }
  }, [_vm._v(" Voltar ")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando
    },
    on: {
      "click": _vm.confirmarESincronizar
    }
  }, [_vm.carregando ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v(" Salvando... ")]) : _c('span', [_vm._v("Confirmar e Sincronizar")])])])]) : _vm._e()])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "setup-header"
  }, [_c('img', {
    staticClass: "setup-logo",
    attrs: {
      "src": "media/brand/logo.png",
      "alt": "PDV Desktop"
    }
  }), _c('h1', [_vm._v("Configuração do Terminal")]), _c('p', {
    staticClass: "setup-subtitle"
  }, [_vm._v("Informe o identificador deste terminal para continuar.")])]);
}];
export { render, staticRenderFns };